export enum ActivityType {
  CALL = "CALL",
  MAIL = "MAIL",
  MEETING = "MEETING",
  OTHER = "OTHER",
}

export enum ActivityStatus {
  OPEN = "OPEN",
  WAITING_FOR_CUSTOMER = "WAITING_FOR_CUSTOMER",
  DONE = "DONE",
}

export enum ActivityResultType {
  POTENTIAL_FUTURE_PROJECT = "POTENTIAL_FUTURE_PROJECT",
  KEEP_CONTACT = "KEEP_CONTACT",
  DO_NOT_KEEP_CONTACT = "DO_NOT_KEEP_CONTACT",
}

export enum ActivityRecurrenceFrequency {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  QUARTERLY = "QUARTERLY",
  SEMIANNUAL = "SEMIANNUAL",
  YEARLY = "YEARLY",
}

export enum ActivityRecurrenceEndType {
  NEVER = "NEVER",
  UNTIL_DATE = "UNTIL_DATE",
  AFTER_N_OCCURRENCES = "AFTER_N_OCCURRENCES",
}

export type ActivityDto = {
  activityId: number;
  contactPersonId: number;
  contactPersonName: string;
  companyId: number;
  companyName: string;
  responsibleUserId: number;
  responsibleUserName: string;
  createdByMemberId: number;
  createdByName: string;
  activityType: ActivityType;
  title: string;
  description: string | null;
  deadline: Date;
  status: ActivityStatus;
  resultType: ActivityResultType | null;
  resultComment: string | null;
  waitingComment: string | null;
  isRecurring: boolean;
  recurrenceFrequency: ActivityRecurrenceFrequency | null;
  recurrenceInterval: number | null;
  recurrenceEndType: ActivityRecurrenceEndType | null;
  recurrenceEndDate: Date | null;
  recurrenceCount: number | null;
  seriesId: string | null;
  completedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
};

export type CreateActivityDto = {
  contactPersonId: number;
  responsibleUserId: number;
  activityType: ActivityType;
  title: string;
  description?: string | null;
  deadline: Date;
  isRecurring?: boolean;
  recurrenceFrequency?: ActivityRecurrenceFrequency | null;
  recurrenceInterval?: number | null;
  recurrenceEndType?: ActivityRecurrenceEndType | null;
  recurrenceEndDate?: Date | null;
  recurrenceCount?: number | null;
};

export type UpdateActivityDto = {
  responsibleUserId: number;
  activityType: ActivityType;
  title: string;
  description: string | null;
  deadline: Date;
  isRecurring: boolean;
  recurrenceFrequency: ActivityRecurrenceFrequency | null;
  recurrenceInterval: number | null;
  recurrenceEndType: ActivityRecurrenceEndType | null;
  recurrenceEndDate: Date | null;
  recurrenceCount: number | null;
};

export type UpdateActivityStatusDto = {
  status: ActivityStatus;
  resultType: ActivityResultType | null;
  resultComment: string | null;
  waitingComment: string | null;
};
